import type { ActivitySummary } from '@painpal/contracts';
import { noLoadLabel, PROCESSING_LABEL } from '../lib/format';
import { HIGH_LOAD, SPORT_COLORS } from '../theme/tokens';
import styles from './LoadCell.module.css';

export interface LoadCellProps {
  activity: ActivitySummary;
  pxPerLoad: number;
  maxBarPx: number;
  onRetry?: (id: string) => void;
  retrying?: boolean;
  pendingLabel?: string;
  showReason?: boolean;
}

export function LoadCell({ activity, pxPerLoad, maxBarPx, onRetry, retrying, pendingLabel = PROCESSING_LABEL, showReason = true }: LoadCellProps) {
  if (activity.status === 'failed') {
    if (onRetry === undefined) return <span className={styles.failed}>FAILED</span>;
    return (
      <button type="button" className={styles.failed} disabled={retrying === true} onClick={() => onRetry(activity.id)}>
        <span data-part="failed-prefix" className="sr-only-phone">FAILED ·</span>{' '}RETRY ↻
      </button>
    );
  }
  if (activity.status === 'pending') return <span className={styles.pending}>{pendingLabel}</span>;
  if (activity.load === null) {
    if (!showReason) return <span className={styles.none}>—</span>;
    return (
      <>
        <span data-part="dash" className={styles.dash} aria-hidden="true">—</span>
        <span className={styles.reason}>{noLoadLabel(activity)}</span>
      </>
    );
  }
  const width = Math.min(maxBarPx, Math.max(2, Math.round(activity.load * pxPerLoad)));
  return (
    <span className={styles.load} data-part="load">
      <span className={styles.bar} data-high={activity.sport === 'ride' && activity.load >= HIGH_LOAD} style={{ width, ...(activity.sport === 'ride' ? {} : { background: SPORT_COLORS[activity.sport] }) }} aria-hidden="true" />
      {Math.round(activity.load)}
    </span>
  );
}
